import { render, staticRenderFns } from "./SubInvoices.vue?vue&type=template&id=1457cb0a&scoped=true"
import script from "./SubInvoices.vue?vue&type=script&lang=js"
export * from "./SubInvoices.vue?vue&type=script&lang=js"
import style0 from "./SubInvoices.vue?vue&type=style&index=0&id=1457cb0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457cb0a",
  null
  
)

/* custom blocks */
import block0 from "./SubInvoices.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports